export const DEFAULT_B2C_COHORT_ID = 'TEST_B2C_2024';

export const STORAGE_KEY = 'ai-navigator-survey-progress';

export const DIMENSION_NAMES = {
  D01: 'AI Awareness',
  D02: 'Data Safety',
  D03: 'Governance & Compliance',
  D04: 'Tool Adoption',
  D05: 'Ethical AI',
  D06: 'Prompting Skills',
  D07: 'Org AI Readiness',
  D08: 'Partnering With AI',
  D09: 'AI Mindset',
  D10: 'Learning & Adaptability',
  D11: 'AI Value & Results',
  D12: 'AI Innovation & Influence',
};

export const DEFAULT_INSIGHT_MESSAGES = {
  D01: "Understanding the 'how' behind AI is the first step to control. You've shown a strong foundational grasp.",
  D02: "Privacy is a core competency. Protecting data isn't just IT's job — it's yours.",
  D03: 'Governance provides guardrails for innovation. Policy is your professional safety net.',
  D04: 'Operations is where theory becomes productivity. Flow is a key indicator of readiness.',
  D05: 'Verification is the bridge between AI efficiency and professional accountability.',
  D06: 'Strategic prompting turns AI from a toy into a precision instrument. It is a fundamental leadership skill.',
  D07: 'The future of work is a hybrid of human judgement and machine scale. Collaboration is the key.',
  D08: 'AI supports decisions; it does not make them. Maintaining agency is critical to integrity.',
  D09: 'Innovation requires the safety to experiment and the courage to fail quietly within defined boundaries.',
  D10: 'In an AI world, the ability to unlearn is as valuable as the ability to learn. Agility is your edge.',
  D11: 'Maturity is measured by outcomes — not by how many windows you have open or prompts you send.',
  D12: "True innovation is finding the use-cases that don't exist yet — and sharing those insights.",
};

export const AUTO_ADVANCE_DELAY = 400;
export const SAVED_PROGRESS_EXPIRY_DAYS = 7;
